export default "__VITE_ASSET__KvxwDuSB__"